import React, { useCallback } from "react";
import { Form } from "react-final-form";
import { isFormChanged, isFormValid } from "shared/validators";
import { DIALOG_ACTION_TITLE, INCORRECT_INPUTS_MESSAGE, VariantLabels } from "shared/labels";
import Input from "rs-components/Input";
import TextInput from "rs-components/Input/components/TextInput";
import Dialog from "components/Dialog";
import * as styles from "./styles.module.scss";
var FormFields;
(function (FormFields) {
    FormFields["NAME"] = "name";
})(FormFields || (FormFields = {}));
const RenameDialog = ({ onSubmit, onClose, name, nameValidationError, onSetValidationError }) => {
    const resetErrors = useCallback(() => {
        if (nameValidationError) {
            onSetValidationError("");
        }
    }, [nameValidationError, onSetValidationError]);
    const handleClose = useCallback(() => {
        onClose();
        onSetValidationError("");
    }, [onClose, onSetValidationError]);
    return (React.createElement(Form, { onSubmit: onSubmit, validateOnBlur: true }, ({ handleSubmit, form, ...renderProps }) => (React.createElement(Dialog, { isOpen: true, title: VariantLabels.RENAME_VARIANT, primaryButton: {
            label: DIALOG_ACTION_TITLE.OK,
            onClick: isFormChanged(renderProps) ? handleSubmit : handleClose,
            disabled: !isFormValid(renderProps) || !!nameValidationError,
            title: !isFormValid(renderProps) || !!nameValidationError ? INCORRECT_INPUTS_MESSAGE : "",
        }, secondaryButtons: [{ label: DIALOG_ACTION_TITLE.CANCEL, onClick: handleClose }], onClosing: form?.reset },
        React.createElement("div", { className: styles.root },
            React.createElement(Input, { component: TextInput, name: FormFields.NAME, autoComplete: "off", classes: { component: styles.field }, label: "Name", restrictions: { IsMandatory: true, Default: name }, externalError: nameValidationError, onChange: resetErrors }))))));
};
export default RenameDialog;
